<template>
  <router-link :to="to" class="mobius-logo" :class="{ 'mobius-logo--sm': size === 'sm', 'mobius-logo--light': variant === 'light' }">
    <img src="/images/mobius-logo-compact.svg" alt="Mobius" class="mobius-logo__img" />
    <span class="mobius-logo__text">
      <span class="mobius-logo__word">Mobius</span>
      <span class="mobius-logo__slogan">Potenciar, Multiplicar, Sumar</span>
    </span>
  </router-link>
</template>

<script>
export default {
  name: "MobiusLogo",
  props: {
    to: {
      type: String,
      default: "/home",
    },
    size: {
      type: String,
      default: "md",
      validator: (v) => ["sm", "md"].includes(v),
    },
    variant: {
      type: String,
      default: "default",
      validator: (v) => ["default", "light"].includes(v),
    },
  },
};
</script>

<style scoped>
.mobius-logo {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
}

.mobius-logo__img {
  height: 48px;
  width: auto;
}

.mobius-logo__text {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}

.mobius-logo__word {
  font-weight: 700;
  font-size: 1.5rem;
  color: #1a1a1a;
}

.mobius-logo__slogan {
  font-size: 0.75rem;
  font-weight: 500;
  color: #4a4a4a;
}

.mobius-logo--sm .mobius-logo__img {
  height: 36px;
}

.mobius-logo--sm .mobius-logo__word {
  font-size: 1.1rem;
}

.mobius-logo--sm .mobius-logo__slogan {
  font-size: 0.65rem;
}

.mobius-logo--light .mobius-logo__word {
  color: #fff;
}

.mobius-logo--light .mobius-logo__slogan {
  color: rgba(255, 255, 255, 0.85);
}
</style>
